/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { UpdateTeacherDataViewModel } from "../types/UpdateTeacherDataViewModel.ts";
import { eAcademicEducationSchema } from "./eAcademicEducationSchema.ts";
import { eUspContractTypeSchema } from "./eUspContractTypeSchema.ts";

export const updateTeacherDataViewModelSchema = z.object({
  observation: z
    .string()
    .describe("Observações gerais sobre o docente.")
    .nullish(),
  isUspTeaching: z
    .boolean()
    .describe(
      "Indica se o docente possui vínculo de ensino com a USP. Opcional.",
    )
    .nullish(),
  codeUSP: z.string().describe("Código USP do docente.").nullish(),
  certNumber: z
    .string()
    .describe("Número do certificado CERT do docente.")
    .nullish(),
  uspContractType: z.optional(
    z
      .lazy(() => eUspContractTypeSchema)
      .describe("1 = RTC | 2 = RTP | 3 = RDIDP | 4 = Aposentado | "),
  ),
  certWorkload: z
    .number()
    .describe("Carga horária do CERT do docente. Opcional.")
    .nullish(),
  certExpirationDate: z
    .string()
    .datetime()
    .describe("Data de validade do certificado CERT do docente. Opcional.")
    .nullish(),
  isLattes: z
    .boolean()
    .describe(
      "Indica se o docente possui currículo Lattes cadastrado. Opcional.",
    )
    .nullish(),
  lattesUpdateDate: z
    .string()
    .datetime()
    .describe(
      "Data da última atualização do currículo Lattes do docente. Opcional.",
    )
    .nullish(),
  academicEducation: z.optional(
    z
      .lazy(() => eAcademicEducationSchema)
      .describe(
        "1 = UndergraduateDegree | 2 = Technologist | 3 = PostgraduateDegree | 4 = MasterDegree | 5 = DoctorateDegree | 6 = BachelorDegree | 7 = HighSchool | 8 = Specialist | ",
      ),
  ),
  businessSectorId: z
    .number()
    .int()
    .describe("ID do setor de atuação do docente. Opcional.")
    .nullish(),
  otherBusinessSector: z
    .string()
    .describe(
      "Descrição de outro setor de atuação do docente, quando não listado. Opcional.",
    )
    .nullish(),
  academicInstitutionId: z
    .number()
    .int()
    .describe("ID da instituição acadêmica de vínculo do docente. Opcional.")
    .nullish(),
}) as unknown as ToZod<UpdateTeacherDataViewModel>;
